module.exports = __webpack_public_path__ + "static/media/whatsapp_new.46e2f412.svg";